import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PresentacionComponent } from './components/presentation/presentacion.component';
import { FilterPipePre } from '../../pipes/filterPre.pipe';
import { EditPresentationComponent } from './components/edit-presentation/edit-presentation.component';
import { AddPresentationComponent } from './components/add-presentation/add-presentation.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        PresentacionComponent,
        EditPresentationComponent,
        FilterPipePre,
        EditPresentationComponent,
        AddPresentationComponent,
    ],
    exports: [PresentacionComponent, EditPresentationComponent],
    imports: [CommonModule, FormsModule, TranslateModule],
})
export class PresentationModule {}
